<template>
  <div class="app-container">
    <div>
      <p>{{ $t("common.download_template_excel") }}</p>
      <i class="fa fa-download" aria-hidden="true"></i>
      <!-- <a href="/static/dataimport/import_asset_sample.xlsx" download="import_asset_sample">Download</a> -->
      <a
        @click="exportExcelFile"
        >{{$t('common.exportFileExcel')}}</a
      >
    </div>
    <upload-excel-component :on-success="handleSuccess" :before-upload="beforeUpload"/>
    <b-table
      striped hover small 
      :items="resultImportList"
      :fields="resultImportList_fields"
      class="mt-3"
      outlined
      :busy="isLoading"
    >
        <template v-slot:table-busy>
            <div class="text-center text-danger my-2">
                <b-spinner class="align-middle"></b-spinner>
                <strong>{{$t('reportLiabilitiesReport.loading')}}</strong>
            </div>
        </template>
      <template #head()="scope">
        <div>{{ $t(scope.label) }}</div>
      </template>
      <template #cell(statusImport)="row">
        <!-- {{row}} -->
        <p style="color:green" v-if="row.item.statusImport == importFromExcelEnum.PASS">
          {{ $t(getStatusImportExcel(row.item.statusImport)) }}
        </p>
        <p style="color:red" v-else-if="row.item.statusImport == importFromExcelEnum.ERROR">
          {{ $t(getStatusImportExcel(row.item.statusImport)) }}</p>
        <p style="color:blue" v-else-if="row.item.statusImport == importFromExcelEnum.EXISTS">
          {{ $t(getStatusImportExcel(row.item.statusImport)) }}
        </p>
      </template>
    </b-table>

    <div class="box-footer">
      <button
        id="cmdCancel"
        type="button"
        class="btn btn-default"
        @click="CancelList"
        style="margin-right: 5px;"
      >{{$t('common.back')}}</button>
      <button
        v-if="isShowBtnContinue"
        type="button"
        class="btn btn-success pull-right"
        @click="onConfirm(isConfirmContinue = true)"
      >{{$t('common.btnContinue')}}</button>
      <button
        v-if="isShowBtnUpdate"
        type="button"
        class="btn btn-primary pull-right"
        style="margin-right: 10px"
        @click="onConfirm(isConfirmUpdate = true)"
      >{{$t('common.btnUpdate')}}</button>
    </div>
    <!--  -->
    <lte-core-alert
      v-for="snackbar in GET_SNACK_BAR"
      :key="snackbar.id"
      :item="snackbar"
    ></lte-core-alert>
    <!--  -->
    <loading
      :active.sync="isLoading"
      :can-cancel="false"
      color="#1E90FF"
    ></loading>
    <!--  -->
    <lte-modal
      v-show="isModalVisible"
      @onConfirm="onConfirmOverWrite"
      @close="closeModal"
      v-for="obj in objModal"
      :key="obj.id"
      :item="obj"
    ></lte-modal>
    <!--  -->
  </div>
</template>

<script>
import UploadExcelComponent from "@/components/UploadExcel/index.vue";

import { mapGetters, mapActions } from "vuex";
import XLSX from "xlsx";
import utils from "@/lib/utils";
import ImportFromExcelEnum from "@/enum/importFromExcelEnum"
import LTEModal from "@/components/LTEModal.vue";
import LTECoreAlert from "@/components/LTESnackBar.vue";
import Loading from "vue-loading-overlay";

export default {
  name: "AssetImportExcel",
  components: {
    UploadExcelComponent,
    "lte-core-alert": LTECoreAlert,
    loading: Loading,
    "lte-modal": LTEModal
  },
  data() {
    return {
      hdBackground: "background-color: #4b646f;border:1px solid white;", //00a65a

      resultImportList: [], // Result import
      resultImportList_fields: [
        {
          key: "asset_name",
          label: 'escalationprocess.name',
          sortable: true,
          class: "text-center"
        },
        {
          key: "statusImport",
          label: 'common.status',
          sortable: true,
          class: "text-center"
        },
        {
          key: "errorDetail",
          label: 'common.error',
          sortable: true,
          class: "text-center"
        }
      ],
      isLoading: false,
      validateElement: {},
      importFromExcelEnum: ImportFromExcelEnum,
      numberAssetExists: 0,
      isShowBtnUpdate: false,
      isShowBtnContinue: false,
      isConfirmContinue: false,
      isConfirmUpdate: false,
      importExcelData: {
        results: null,
        header: null
      },
      objModal: [
        {
          title: "common.delete_modal.notiTitle",
          body: "common.importExcel.overWriteImportNoti",
          buttonNo: "common.delete_modal.btnNo",
          buttonYes: "common.delete_modal.btnYes",
          styleType: "default"
        }
      ],
      isModalVisible: false
    };
  },
  watch: {},
  computed: {
    ...mapGetters([
      "GET_SNACK_BAR"
    ])
  },
  methods: {
    ...mapActions([
        "IMPORT_ASSET_EXCEL",
        "SUCCESS_TOAST"
    ]),
    getStatusImportExcel: function(value) {
      return utils.getStatusImportExcel(value)
    },
    beforeUpload(file) {
      const isLt1M = file.size / 1024 / 1024 < 1;

      if (isLt1M) {
        return true;
      }

      this.$message({
        message: "Please do not upload files larger than 1m in size.",
        type: "warning"
      });
      return false;
    },
   
    handleSuccess({ results, header }) {
      this.importExcelData.results = results
      this.importExcelData.header = header
      this.isShowBtnUpdate = false
      this.isShowBtnContinue = false
      this.isConfirmContinue = false
      this.isConfirmUpdate = false
      this.handleImportExcel()
    },
    handleImportExcel: function() {
      let data = {
        headers: this.importExcelData.header,
        dataImport: this.importExcelData.results,
        isConfirmContinue: this.isConfirmContinue,
        isConfirmUpdate: this.isConfirmUpdate
      };
      // init empty
      this.resultImportList = []
      this.isLoading = true
      this.IMPORT_ASSET_EXCEL(data)
        .then(
          function(res) {
            res.dataResult.forEach(v => {
              let dataPass = {
                asset_name: v.asset_name,
                statusImport: v.status,
                errorDetail: v.error_message
              };
              this.resultImportList.push(dataPass);
            });
            this.numberAssetExists = res.number_asset_exists
            if (this.numberAssetExists > 0 && res.is_confirm_continue === false && res.is_confirm_update === false) {
              this.isShowBtnUpdate = true
              this.isShowBtnContinue = true
            } else {
              this.isShowBtnUpdate = false
              this.isShowBtnContinue = false
            }
            this.isLoading = false
          }.bind(this)
        )
        .catch(
          function(error) {
            let dataError = {
              asset_name: "Unknown",
              statusImport: "FAIL",
              errorDetail: "Unknown"
            };
            this.resultImportList.push(dataError);
            this.isLoading = false
          }.bind(this)
        );
    },
    onConfirm: function() {
      if (this.numberAssetExists > 0 && this.isConfirmUpdate && !this.isConfirmContinue) {
        this.isModalVisible = true;
      } else {
        this.handleImportExcel()
      }
    },
    CancelList: function() {
      this.$router.push({
        name: "AssetList"
      });
    },
    exportExcelFile: function() {
      let data_list = []
      let json_data = [
        {
          "Mã gốc": "asset_1",
          "Mã thiết bị": "",
          "Mã đơn vị": "0000",
          "Mã phân loại": "000",
          "Tên thiết bị": "Tai san 1",
          "Số lượng": "1",
          "Vị trí": "",
          "Mã nhà cung cấp": "",
          "Xuất xứ": "",
          "Thời điểm sản xuất": "",
          "Model": "",
          "Thời hạn bảo hành": ""
        }
      ]

      data_list= json_data
      // export json to Worksheet of Excel
      // only array possible
      var assetFile = XLSX.utils.json_to_sheet(data_list);
      // var pokemonWS = XLSX.utils.json_to_sheet(this.Datas.pokemons)

      // A workbook is the name given to an Excel file
      var wb = XLSX.utils.book_new(); // make Workbook of Excel

      // add Worksheet to Workbook
      // Workbook contains one or more worksheets
      XLSX.utils.book_append_sheet(wb, assetFile, "assetFile"); // sheetAName is name of Worksheet
      // XLSX.utils.book_append_sheet(wb, pokemonWS, 'pokemons')

      // export Excel file
      XLSX.writeFile(wb, "assetFile.xlsx", { bookType: 'xlsx', type: 'buffer' }); // name of the file is 'book.xlsx'
    },
    closeModal() {
      this.isModalVisible = false;
    },
    onConfirmOverWrite: function() {
      this.isModalVisible = false;
      this.handleImportExcel()
    },
  },
  mounted() {}
};
</script>



// WEBPACK FOOTER //
// src/views/Property/AssetImportExcel.vue